import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { openApp } from 'lib/helpers'

import { toggleDefaultConfirmBox } from 'store/actions/confirmBox'

const useGlobalConfirmBox = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const showConfirmBox = useCallback(
    (params) =>
      dispatch(
        toggleDefaultConfirmBox({
          ...params,
          confirmBoxProps: {
            cancelText: t('common.cancel'),
            ...params.confirmBoxProps,
          },
        })
      ),
    [dispatch, t]
  )

  const showErrorBox = useCallback(
    (params) =>
      dispatch(
        toggleDefaultConfirmBox({
          ...params,
          confirmBoxProps: {
            confirmButtonText: t('common.yes'),
            ...params.confirmBoxProps,
          },
        })
      ),
    [dispatch, t]
  )

  const showSuggestToUseOnAppConfirmBox = useCallback(
    (params = {}) => {
      dispatch(
        toggleDefaultConfirmBox({
          title: t('global_confirm_box.suggest_to_use_app.title'),
          content: t('global_confirm_box.suggest_to_use_app.content'),
          ...params,
          confirmBoxProps: {
            confirmButtonText: t(
              'global_confirm_box.suggest_to_use_app.confirm_text'
            ),
            onOk: () => openApp(),
            cancelText: t('global_confirm_box.suggest_to_use_app.cancel_text'),
            ...params.confirmBoxProps,
          },
        })
      )
    },
    [dispatch, t]
  )

  return {
    showSuggestToUseOnAppConfirmBox,
    showConfirmBox,
    showErrorBox,
  }
}

export default useGlobalConfirmBox
